import React from 'react';
import MainLayout from '../layouts/MainLayout';
import Hero from '../components/Hero';
import ServicesGrid from '../components/ServicesGrid';
import ProcessSection from '../components/ProcessSection';
import { generateLocalBusinessSchema, pageMeta } from '../lib/seo';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import { ArrowRight, Phone, Mail } from 'lucide-react';

const HomePage = () => {
  const structuredData = generateLocalBusinessSchema();

  return (
    <MainLayout
      title={pageMeta.home.title}
      description={pageMeta.home.description}
      keywords={pageMeta.home.keywords}
      structuredData={structuredData}
    >
      {/* Hero Section */}
      <Hero />

      {/* Services Preview */}
      <section className="section-container">
        <ServicesGrid limit={6} />
      </section>

      {/* Process Section */}
      <ProcessSection />

      {/* CTA Section */}
      <section className="w-full bg-primary-skin/20 pt-8 md:pt-12 pb-16 md:pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-soft border border-primary-gray-border text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary-text-dark mb-6">
            Bereit für Ihre nächste Herausforderung?
          </h2>
          <p className="text-lg md:text-xl text-primary-text-muted mb-8 max-w-2xl mx-auto">
            Kontaktieren Sie uns noch heute für ein unverbindliches Angebot.
            Unser Team steht Ihnen mit Rat und Tat zur Seite.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <Link to="/kontakt">
              <Button variant="primary" size="lg" icon={ArrowRight} iconPosition="right">
                Jetzt Kontakt aufnehmen
              </Button>
            </Link>
            <a href="tel:+491783620226">
              <Button variant="secondary" size="lg" icon={Phone}>
                +49178 3620226
              </Button>
            </a>
          </div>
          <div className="flex items-center justify-center space-x-2 text-primary-text-muted">
            <Mail className="w-5 h-5" />
            <a href="mailto:kontakt@senkay-personallogistik.de" className="hover:text-primary-text-dark transition-colors">
              kontakt@senkay-personallogistik.de
            </a>
          </div>
        </div>
        </div>
      </section>
    </MainLayout>
  );
};

export default HomePage;
